module.exports = __webpack_public_path__ + "media/images/icon_plus2-53fc624f2dc1e8b2ac1b368984d72b14.svg";